import * as React from "react";
import { Column } from "primereact/column";
import { Modal, ModalHeader, ModalBody, ModalFooter, Row, Col, Button } from "reactstrap";
import { Link } from "react-router-dom";
import PageLayout from "../../components/PageLayout";
import useEntitiesList from "../../utils/listHookNew";
import { useAuth0 } from "../../auth/react-auth0-wrapper";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { DataTable } from "primereact/datatable";
import { DropdownFilterElement, renderHeader } from "../../components/TableUtils";
import Can from "../../auth/Can";
import { Checkbox } from 'primereact/checkbox';
import roles from "../../auth/roles";
import { deleteProduct } from "../../api/products";

export default function ProductsList({ opt, activeTenant, showAll }) {
    const { domains, user } = useAuth0();
    let dtable;

    const [result, loading, setLoading, globalFilter, setGlobalFilter, forceRefresh] = useEntitiesList("products", "products.attributes->'description'", !showAll ? `tenant_id = '${activeTenant._id}'` : undefined, "")

    const [openModal, setOpenModal] = React.useState(false);
    const toggle = () => setOpenModal(!openModal);

    const onDelete = async id => {
        const value = await deleteProduct(id);
        toggle();
        forceRefresh();
        return value;
    };

    const modalSection = () => (
        <Modal zIndex={2000} centered size="sm" isOpen={openModal ? true : false} backdrop={true}>
            <ModalHeader toggle={toggle}>
                Eliminazione Prodotto
        </ModalHeader>
            <ModalBody>
                <p>Confermi di voler eliminare il Prodotto?</p>
            </ModalBody>
            <ModalFooter>
                <Button color="link" className="btn-link-dark" onClick={toggle}>Annulla</Button>{' '}
                <Button color="danger" className="ml-auto" onClick={() => onDelete(openModal._id)}>Elimina</Button>
            </ModalFooter>
        </Modal>
    );

    const getHeader = () => {
        if (showAll) return null;
        return (
            <Can
                roles={[roles.ADMIN]}
                yes={() =>
                    <div className="action-container">
                        <Link
                            title="Aggiungi prodotto"
                            className="btn btn-primary p-button-icon-only"
                            to={`/tenant/products-add`}
                        >
                            <FontAwesomeIcon icon="align-center" className="mr-1" />Nuovo Prodotto
                        </Link>
                    </div>
                }
                no={() => null}
            />
        );
    };

    const getGridBoolTemplate = (rowData, column) => {
        const value = rowData.attributes && rowData.attributes.needsAuto.toString() === "true" ? true : false;
        return <Checkbox readOnly disabled onChange={() => null} checked={(value && true) || false} />;
    }

    const onRefresh = () => {
        forceRefresh();
        setGlobalFilter("");
    }

    const exportTable = () => {
        dtable.exportCSV();
    }

    return (
        <PageLayout title={`Elenco Prodotti - Dealer: ${activeTenant.name}`}>
            <Row>
                <Col>
                    <DataTable
                        ref={el => {
                            dtable = el;
                        }}
                        loading={loading}
                        value={result}
                        rowsPerPageOptions={[5, 10, 20, 50, 100]}
                        className="p-datatable-hoverable-rows p-datatable-customers"
                        responsive
                        paginator={true}
                        autoLayout={false}
                        first={0}
                        rows={20}
                        totalRecords={result.length}
                        paginatorPosition="both"
                        header={renderHeader(loading, result.length, undefined, getHeader(), { globalFilter, setGlobalFilter, onRefresh }, exportTable)}
                        globalFilter={globalFilter}
                        emptyMessage={() => (<div className="text-center">Nessun prodotto in tabella</div>)}
                        paginatorTemplate="RowsPerPageDropdown CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink"
                        currentPageReportTemplate="Visualizzati {first} di {last} Prodotti su un totale di {totalRecords}"
                    >
                        <Column
                            field="attributes.description"
                            header="Descrizione"
                            sortable
                            filter
                            filterMatchMode="contains"
                            style={{ wordWrap: "break-word" }}
                            body={(rowData, column) => {
                                return (
                                    <Link
                                        to={`/tenant/products-view/${rowData._id}`}
                                    >
                                        {rowData.attributes.description}
                                    </Link>
                                );
                            }}
                        />
                        {showAll && (<Column
                            field="tenant"
                            header="Dealer"
                            sortable
                            filter
                            filterMatchMode="contains"
                            style={{ wordWrap: "break-word" }}
                        />
                        )}
                        <Column
                            field="attributes.type"
                            style={{ wordWrap: "break-word" }}
                            header="Tipo"
                            sortable
                            body={el => domains.devicesType.find(item => el.attributes && item.value === el.attributes.type).label}
                            filter
                            filterElement={
                                <DropdownFilterElement
                                    field="attributes.type"
                                    options={domains.devicesType}
                                    onChange={e => dtable.filter(e.value, e.field)}

                                />
                            }
                        />
                        <Column
                            field="attributes.model"
                            header="Modello"
                            sortable
                            filter
                            filterMatchMode="contains"
                            style={{ wordWrap: "break-word" }}
                        />
                        <Column
                            field="attributes.duration"
                            header="Durata (mesi)"
                            sortable
                            filter
                            style={{ wordWrap: "break-word" }}
                        />
                        <Column
                            field="attributes.needsAuto"
                            header="Veicolo"
                            sortable
                            filter
                            body={getGridBoolTemplate}
                            filterElement={
                                <DropdownFilterElement
                                    field="attributes.needsAuto"
                                    options={[{ label: 'si', value: 'true' }, { label: 'no', value: 'false' }]}
                                    onChange={e => dtable.filter(e.value, e.field)}
                                />
                            }
                            style={{ wordWrap: "break-word" }}
                        />
                        {user.isInRole([roles.ADMIN]) && (
                            <Column
                                field="attributes.price"
                                header="Prezzo (Euro/mese)"
                                sortable
                                filter
                                style={{ wordWrap: "break-word" }}
                            />
                        )}

                        {user.isInRole([roles.ADMIN]) && (
                            <Column
                                field="attributes.quotaAgent"
                                header="Provv. agente"
                                sortable
                                filter
                                style={{ wordWrap: "break-word" }}
                            />
                        )}
                        <Column
                            field="actions"
                            body={(rowData, column) => {
                                return (
                                    <div className="action-container">
                                        <Can
                                            roles={[roles.ADMIN]}
                                            yes={() =>
                                                <Link
                                                    title="Gestisci prodotto"
                                                    className="btn btn-sm btn-primary p-button-icon-only"
                                                    to={`/tenant/products/${rowData._id}`}
                                                >
                                                    <FontAwesomeIcon icon="pencil-alt" />
                                                </Link>
                                            }
                                            no={() => (<Link
                                                title="Visualizza prodotto"
                                                className="btn btn-sm btn-primary p-button-icon-only"
                                                to={`/tenant/products-view/${rowData._id}`}
                                            >
                                                <FontAwesomeIcon icon="eye" />
                                            </Link>)}
                                        />
                                        <Can
                                            roles={[roles.ADMIN]}
                                            yes={() =>
                                                <Button
                                                    color="danger"
                                                    title="Elimina prodotto"
                                                    onClick={() => setOpenModal(rowData)}
                                                    className="btn-sm p-button-icon-only"
                                                >
                                                    <FontAwesomeIcon icon="trash-alt" />
                                                </Button>
                                            }
                                            no={() => null}
                                        />
                                    </div>
                                );
                            }}
                            style={{ wordWrap: "break-word" }}
                        />
                    </DataTable>
                </Col>
            </Row>
            {modalSection()}
        </PageLayout>
    );
}
